import { render, staticRenderFns } from "./BaseFromImage.vue?vue&type=template&id=668ce0ff&scoped=true"
import script from "./BaseFromImage.vue?vue&type=script&lang=js"
export * from "./BaseFromImage.vue?vue&type=script&lang=js"
import style0 from "./BaseFromImage.vue?vue&type=style&index=0&id=668ce0ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ce0ff",
  null
  
)

export default component.exports